import { useTranslation } from 'react-i18next';
import { Preloader } from '@/components/Preloader';
import './index.scss';

export const ProcessingLoader = ({ loading }) => {
  const { t } = useTranslation('modal');

  return (
    loading && (
      <div className="processing_loader">
        <div className="processing_content">
          <div className="processing_text f-20 f-400">{t('processing')}</div>
          <Preloader />
        </div>
      </div>
    )
  );
};
